import { forwardRef } from 'react';

/**
 * Baustein CardSymbolIcons — Marken-Symbole der Brettkarte
 *
 * `<LoyaltyIcon size={16} />`, `<DefenseIcon size={22} />`
 *
 * Umriss-Symbole nach dem Vorbild der gedruckten Kartensymbole, vereinfacht zugunsten der Zahl darin:
 * Loyalität als Wappenschild (flache Kerbe oben, senkrechte Seiten, stumpfe Spitze unten — die
 * senkrechten Seiten unterscheiden es von einem Herz), Verteidigung als achtzackiger Stern mit kurzen
 * Zacken. Beide füllen die volle Höhe des Rahmens, die Mitte bleibt frei für eine Zahl. Props und
 * Zeichenweise wie bei lucide-react:
 * `size` (Standard 24) setzt Breite und Höhe, `ref`, `className` und alle übrigen Props gehen an das `svg`.
 */
const CardSymbol = forwardRef(function CardSymbol({ size = 24, className, children, ...rest }, ref) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      {children}
    </svg>
  );
});

export const LoyaltyIcon = forwardRef(function LoyaltyIcon(props, ref) {
  return (
    <CardSymbol ref={ref} {...props}>
      <path d="M1.5 1.5H8.5Q12 5 15.5 1.5H22.5V13.5Q22 18 12 22.5Q2 18 1.5 13.5Z" />
    </CardSymbol>
  );
});

export const DefenseIcon = forwardRef(function DefenseIcon(props, ref) {
  return (
    <CardSymbol ref={ref} {...props}>
      <path d="M12 1.4L15.2 4.2L19.5 4.5L19.8 8.8L22.6 12L19.8 15.2L19.5 19.5L15.2 19.8L12 22.6L8.8 19.8L4.5 19.5L4.2 15.2L1.4 12L4.2 8.8L4.5 4.5L8.8 4.2Z" />
    </CardSymbol>
  );
});
